import type { Variant } from '@storefront/lib-global/codegen/types';
import { removeDuplicateReducer } from './removeDuplicateReducer';

export const buildUniqueWidths = (variantsInput: Variant[]): string[] =>
  [...variantsInput]
    .sort((a, b) => (a.globalFit ?? '').localeCompare(b.globalFit ?? ''))
    .reduce(removeDuplicateReducer('fitLabel'), []);
